import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { CartComponent } from './cart.component';
import { UserDetailsResolver } from 'src/app/shared/resolvers/user-details.service';
import { StoreService } from 'src/app/shared/resolvers/store.service';
import { MenuService } from 'src/app/shared/resolvers/menu.service';
import { FeatureTagResolver } from 'src/app/shared/resolvers/feature-tag.resolver';
import { ProductGuard } from 'src/app/shared/guard/product.guard';
import { MatDividerModule } from '@angular/material/divider';
import { CartDialogComponent } from './cart-dialog/cart-dialog.component';
import { SkipStopRecurringComponent } from './skip-stop-recurring/skip-stop-recurring.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CanDeactivateGuard } from '../guard/can-deactivate.gaurd';


export const routes = [
  { path: '', component: CartComponent, pathMatch: 'full' , resolve: {userDetails: UserDetailsResolver,store:StoreService},canDeactivate: [CanDeactivateGuard] },
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
  ],
  declarations: [
    CartComponent
  ],
})
export class CartModule { }
